import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../core/ObjectPool.js";

var e = /*#__PURE__*/function () {
  function e(t, _e, l, s) {
    _classCallCheck(this, e);

    this.set(t, _e, l, s);
  }

  _createClass(e, [{
    key: "key",
    get: function get() {
      return this;
    }
  }, {
    key: "id",
    get: function get() {
      return this.toString();
    },
    set: function set(t) {
      this.set(t);
    }
  }, {
    key: "hash",
    get: function get() {
      var t = 4095 & this.row,
          _e3 = 4095 & this.col,
          l = 63 & this.level;

      return (3 & this.world) << 30 | _e3 << 22 | t << 8 | l;
    }
  }, {
    key: "acquire",
    value: function acquire(t, _e4, l, s) {
      this.set(t, _e4, l, s);
    }
  }, {
    key: "contains",
    value: function contains(t) {
      var _e5 = t.level - this.level;

      return this.row === t.row >> _e5 && this.col === t.col >> _e5 && this.world === t.world;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return this.level === t.level && this.row === t.row && this.col === t.col && this.world === t.world;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new e(this);
    }
  }, {
    key: "release",
    value: function release() {
      this.level = 0, this.row = 0, this.col = 0, this.world = 0;
    }
  }, {
    key: "set",
    value: function set(t, _e6, l, s) {
      if (null == t) this.level = 0, this.row = 0, this.col = 0, this.world = 0;else if ("object" == typeof t) this.level = t.level || 0, this.row = t.row || 0, this.col = t.col || 0, this.world = t.world || 0;else if ("string" == typeof t) {
        var _t$split = t.split("/"),
            _t$split2 = _slicedToArray(_t$split, 4),
            _e8 = _t$split2[0],
            _l = _t$split2[1],
            _s = _t$split2[2],
            o = _t$split2[3];

        this.level = parseFloat(_e8), this.row = parseFloat(_l), this.col = parseFloat(_s), this.world = parseFloat(o);
      } else this.level = +t, this.row = +_e6, this.col = +l, this.world = +s || 0;
      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.level, "/").concat(this.row, "/").concat(this.col, "/").concat(this.world);
    }
  }, {
    key: "getParentKey",
    value: function getParentKey() {
      return this.level <= 0 ? null : new e(this.level - 1, this.row >> 1, this.col >> 1, this.world);
    }
  }, {
    key: "getChildKeys",
    value: function getChildKeys() {
      var t = this.level + 1,
          l = this.row << 1,
          s = this.col << 1,
          o = this.world;
      return [new e(t, l, s, o), new e(t, l, s + 1, o), new e(t, l + 1, s, o), new e(t, l + 1, s + 1, o)];
    }
  }, {
    key: "compareRowMajor",
    value: function compareRowMajor(t) {
      return this.row < t.row ? -1 : this.row > t.row ? 1 : this.col < t.col ? -1 : this.col > t.col ? 1 : 0;
    }
  }], [{
    key: "getId",
    value: function getId(t, _e2, l, s) {
      return "object" == typeof t ? "".concat(t.level, "/").concat(t.row, "/").concat(t.col, "/").concat(t.world) : "".concat(t, "/").concat(_e2, "/").concat(l, "/").concat(s);
    }
  }]);

  return e;
}();

e.pool = new t(e, null, null, 25, 50);
export { e as default };